import React from 'react'

function SliderSec2() {

  const wgbslist = [
        {   
            icon: "#1",
            title: "Full Lifecycle Development:",
            desc: "We cover every aspect of your application's journey, from concept to deployment and beyond, ensuring a seamless and robust development process."
        },
        {   
            icon: "#2",
            title: "Application Modernization:",
            desc: "We breathe new life into your existing applications, making them more efficient, secure, and adaptable to the demands of today's digital landscape."
        },
        {   
            icon: "#3",
            title: "App Migration to Cloud:",
            desc: "Seamlessly transition your applications to the cloud, unlocking the power of scalability, flexibility, and cost-efficiency."
        },
        {   
            icon: "#4",
            title: "Enterprise APIs & MicroServices:",
            desc: "Harness the potential of modern microservices architecture and APIs to build agile, interconnected, and scalable systems."
        },
        {   
            icon: "#5",
            title: "Integration Services:",
            desc: "We bring harmony to your systems, ensuring that they work together flawlessly, improving efficiency and data flow."
        },
        {   
            icon: "#6",
            title: "Mobile App Development:",
            desc: "Tap into the vast mobile user base with our expert mobile app development services, making your business accessible to anyone, anywhere."
        },
        {   
            icon: "#7",
            title: "DevOps Cloud/On Premise:",
            desc: "Our DevOps expertise ensures a rapid, reliable, and automated development and deployment process, whether on the cloud or on-premises."
        },
        {   
            icon: "#8",
            title: "IOT-based Applications:",
            desc: "Connect your devices, analyze data, and make informed decisions with our Internet of Things applications."
        },
        {   
            icon: "#9",
            title: "AR/VR-based Applications:",
            desc: "Step into the immersive world of Augmented and Virtual Reality with innovative applications that redefine user experiences."
        },
        {   
            icon: "#10",
            title: "AI/ML-based Applications:",
            desc: "Leverage the power of Artificial Intelligence and Machine Learning to automate processes, gain insights, and make data-driven decisions."
        },
        {   
            icon: "#11",
            title: "Large Enterprise-wide (Monolithic) Applications:",
            desc: "Whether you're running large, complex monolithic systems or transitioning to a more modular approach, we have the experience and solutions to support your needs."
        },
        {   
            icon: "#12",
            title: "Application Management & Maintenance:",
            desc: "Our support doesn't end with deployment; we provide ongoing management and maintenance to ensure your applications continue to perform at their best."
        }
    ]  

  return (
    <section className='wgbs-sec'>
            <div className='container'>
                <ul>
                    {
                        wgbslist.map((Wgbs, index)=>(
                            <li key={index}>
                                <h6> <span className='wgbs-icon' style={{color: "#fff"}}>{Wgbs.icon}</span> <span className='wgbs-head'>{Wgbs.title}</span></h6>
                                <p>{Wgbs.desc}</p>
                            </li> 
                        ))
                    }
                    
                </ul>
                
            </div>
    
        </section>
  )
}

export default SliderSec2
